var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center text-center whitespace-pre-wrap w-200 flex-shrink-0 carousel-item"},[_c('img',{staticClass:"w-80",attrs:{"src":_vm.imageUrl}}),_c('Body',{staticClass:"font-bold"},[_vm._v(_vm._s(_vm.name))]),_c('Body',[_vm._v(_vm._s(_vm.formattedDenominations))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }